import { faUserShield } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

function PrivacyCB() {
  return (
      <div className='mt-2'>
          <div className='jumbotron text-center bg-light border'>
            <FontAwesomeIcon icon={faUserShield} fontSize={128} className='mb-5 text-danger' />
            <h2>Privacy Policy(CashBook)</h2>
            <p>Your privacy is our priority - we've got you covered!</p>
          </div>
          <div className='container'>
              <div className='card bg-light p-3'>
                  <div className='card-body'>
                      <p>This Privacy Policy governs the manner in which CashBook, a mobile application developed by MileSoft, collects, uses, maintains, and discloses information collected from users. This Privacy Policy applies to the CashBook mobile application and all products and services offered by MileSoft.</p>
                      <h6>Data Shared</h6>
                      <p>CashBook does not share any user data with third parties or other companies or organizations.</p>
                      <h6>Data Collected and Purpose</h6>
                      <p>CashBook may collect the following personal information:
                          <ol>
                              <li>Name: Collected for app functionality and account management purposes.</li>
                              <li>Email Address: Collected for app functionality and account management purposes.</li>
                              <li>Other Financial Information: Collected for app functionality purposes.</li>
                          </ol>
                      </p>
                      <h6>Data Deletion</h6>
                      <p>Users have the option to delete their account and associated data for CashBook. A request for data deletion can be submitted through the following link: <a href='https://milesoft.co/delete-account-cb'>Delete Account Request</a>.</p>
                      <p>Please note that currently, the developer has not provided a direct way to request data deletion within the application. For further information on how data is handled, please refer to the developer's privacy policy.</p>
                      <h6>Security Practices</h6>
                      <ol>
                          <li>Data Encryption: All user data is encrypted during transit to ensure a secure connection.</li>
                          <li>Data Deletion Request: The developer provides users with a way to request the deletion of their data.</li>
                      </ol>
                      <h6>Changes to this Privacy Policy</h6>
                      <p>MileSoft has the discretion to update this Privacy Policy at any time. When we do, we will revise the updated date at the bottom of this page. We encourage users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect. You acknowledge and agree that it is your responsibility to review this Privacy Policy periodically and become aware of modifications.</p>
                      <h6>Your Acceptance of these Terms</h6>
                      <p>By using CashBook, you signify your acceptance of this Privacy Policy. If you do not agree to this Privacy Policy, please do not use CashBook. Your continued use of CashBook following the posting of changes to this Privacy Policy will be deemed your acceptance of those changes.</p>
                      <h6>Contacting Us</h6>
                      <p>If you have any questions about this Privacy Policy, the practices of CashBook, or your dealings with this application, please contact us at milesoft.co@gmail.com.</p>
                  </div>
            </div>
          </div>
          <div className='container'>&nbsp;</div>
      </div>
  )
}

export default PrivacyCB